/**
 * revflare-badge-fix.js
 * Keeps the product-page sale badge in sync with the selected variant.
 * Loaded after revflare.js. No dependencies, no globals.
 */
(function () {
  'use strict';

  var BADGE_BLOCK = '.rev-badge__wrapper';
  var SALE_CFG = 'script.rev-cfg[data-rev-cfg-type="sale_badge"]';
  var VARIANT_SELECTOR = '.rev-variant-selector';
  var SALE_BADGE = '.rev-badge.rev-badge__sale';
  var BADGE_WRAPPER = '.rev-badge__wrapper';

  function parseJson(node) {
    if (!node) return null;
    try {
      var raw = node.textContent || node.innerHTML || '';
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (err) {
      return null;
    }
  }

  function scopeFor(el) {
    if (!el.closest) return document;
    return el.closest('[data-product-id]') || el.closest('.shopify-section') || document;
  }

  function readCfg(block) {
    var cfg = parseJson(block.querySelector(SALE_CFG));
    if (!cfg || !cfg.variants || !cfg.variants.length) return null;
    return cfg;
  }

  function variantIdFromInput(block, scope) {
    var input = block.querySelector('input[name="id"]');
    if (!input && scope && scope !== block && scope.querySelector) {
      input = scope.querySelector('input[name="id"]');
    }
    if (input && input.value) return String(input.value);
    return null;
  }

  function variantIdFromUrl() {
    var match = window.location.search.match(/[?&]variant=([^&]+)/);
    if (!match) return null;
    try {
      return decodeURIComponent(match[1]);
    } catch (err) {
      return match[1];
    }
  }

  function variantIdFromSelector(cfg, scope) {
    var selector = null;
    if (cfg.productId !== undefined && cfg.productId !== null) {
      selector = document.querySelector(VARIANT_SELECTOR + '[data-product-id="' + cfg.productId + '"]');
    }
    if (!selector && scope && scope !== document && scope.querySelector) {
      selector = scope.querySelector(VARIANT_SELECTOR);
    }
    if (!selector) selector = document.querySelector(VARIANT_SELECTOR);
    if (!selector) return null;

    var data = parseJson(
      selector.querySelector('script.rev-cfg[data-rev-cfg-type="variant_selector"]') ||
      selector.querySelector('script.rev-cfg')
    );
    if (!data || !data.variants || !data.variants.length) return null;

    var options = [];
    var known = false;
    var i;

    var radios = selector.querySelectorAll('input[data-option-position]');
    for (i = 0; i < radios.length; i++) {
      if (!radios[i].checked) continue;
      var rPos = parseInt(radios[i].getAttribute('data-option-position'), 10) - 1;
      if (rPos >= 0) {
        options[rPos] = radios[i].value;
        known = true;
      }
    }

    var selects = selector.querySelectorAll('select[data-option-position]');
    for (i = 0; i < selects.length; i++) {
      var sPos = parseInt(selects[i].getAttribute('data-option-position'), 10) - 1;
      if (sPos >= 0 && selects[i].value) {
        options[sPos] = selects[i].value;
        known = true;
      }
    }

    if (!known) return null;

    for (i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      if (options[0] && String(v.option1) !== String(options[0])) continue;
      if (options[1] && String(v.option2) !== String(options[1])) continue;
      if (options[2] && String(v.option3) !== String(options[2])) continue;
      if (v.id === undefined || v.id === null) return null;
      return String(v.id);
    }
    return null;
  }

  function findVariant(cfg, id) {
    for (var i = 0; i < cfg.variants.length; i++) {
      if (String(cfg.variants[i].id) === String(id)) return cfg.variants[i];
    }
    return null;
  }

  function ensureBadge(block, style) {
    var badge = block.querySelector(SALE_BADGE);
    if (badge) return badge;
    var wrapper = (block.matches && block.matches(BADGE_WRAPPER)) ? block : block.querySelector(BADGE_WRAPPER);
    if (!wrapper) return null;
    badge = document.createElement('span');
    badge.className = 'rev-badge rev-badge__sale';
    if (style) badge.setAttribute('style', style);
    var text = document.createElement('span');
    text.className = 'rev-badge__text';
    badge.appendChild(text);
    wrapper.appendChild(badge);
    return badge;
  }

  function readLabel(badge) {
    var text = badge ? badge.querySelector('.rev-badge__text') : null;
    return text ? (text.textContent || '') : '';
  }

  function update(block) {
    var cfg = readCfg(block);
    if (!cfg) return;

    var scope = scopeFor(block);
    var id = variantIdFromInput(block, scope) || variantIdFromUrl() || variantIdFromSelector(cfg, scope);
    if (!id) return;

    var variant = findVariant(cfg, id);
    if (!variant) return;

    var label = variant.label ? String(variant.label) : '';
    var badge = block.querySelector(SALE_BADGE);

    if (!label) {
      if (badge && badge.style.display !== 'none') badge.style.display = 'none';
      return;
    }

    badge = ensureBadge(block, cfg.style);
    if (!badge) return;

    var text = badge.querySelector('.rev-badge__text');
    if (!text) {
      text = document.createElement('span');
      text.className = 'rev-badge__text';
      badge.appendChild(text);
    }

    if (readLabel(badge) !== label) text.textContent = label;
    if (badge.style.display !== '') badge.style.display = '';
  }

  function updateAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var blocks = scope.querySelectorAll(BADGE_BLOCK);
    for (var i = 0; i < blocks.length; i++) update(blocks[i]);
  }

  function init() {
    document.addEventListener('change', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      var selector = target.closest(VARIANT_SELECTOR);
      if (!selector) return;
      var scope = selector.closest('.shopify-section') || document;
      window.setTimeout(function () {
        updateAll(scope);
      }, 0);
    }, true);

    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target) updateAll(e.target);
    });

    updateAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
